<template>
  <div>
    <section class="section is-title-bar">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <h1 class="title is-5">{{ title }}</h1>
          </div>
        </div>
        <router-link slot="right" :to="{ name: 'FeeTypeList' }" class="button is-small is-link">Back to list</router-link>
      </div>
    </section>
    <section class="container section page-header section is-main-section">
      <form @submit.prevent="saveFeeStructure">
        <div>
          <card-component>
            <div class="columns">
              <div class="column">
                <div class="columns is-mobile">
                  <div class="column">
                    <div class="field">
                      <label class="label">
                        Name
                        <span class="has-text-danger">*</span>
                      </label>
                      <input class="input" type="text" placeholder="Name.." required v-model.trim="FeeTypeObj.name" />
                    </div>

                     <div class="field">
                      <b-checkbox v-model="isService"> <b>Is Service </b> </b-checkbox>
                    </div>

                    <div class="field">
                      <label class="label">
                        Priority
                        <span class="has-text-danger">*</span>
                      </label>
                      <input class="input" type="number" placeholder="priority.." min="0" required v-model.trim="FeeTypeObj.priority" />
                    </div>

                    <div class="field">
                      <label class="label">
                        Level
                        <span class="has-text-danger">*</span>
                      </label>
                      <div class="control select is-fullwidth">
                        <select required v-model.trim="FeeTypeObj.level">
                          <option value>---Select---</option>
                          <option>ADMIN</option>
                          <option>FRANCHISEE</option>
                        </select>
                      </div>
                    </div>

                    <label class="label">
                      Fee Type
                      <span class="has-text-danger">*</span>
                    </label>
                    <div class="control is-fullwidth">
                      <div>
                        <multiselect
                          class="overflowmultiselect1"
                          :close-on-select="false"
                          :clear-on-select="false"
                          :preserve-search="false"
                          :preselect-first="false"
                          :multiple="true"
                          :options="feeType"
                          v-model.trim="feeTypeID"
                          track-by="id"
                          label="name"
                          ><template slot="tags" slot-scope="{ values }"
                            ><span class="multiselect__single" v-if="values.length">
                              {{ values.name }}
                            </span></template
                          >
                        </multiselect>
                      </div>
                    </div>

                    <div class="field">
                      <label class="label"> </label>
                    </div>
                    <div class="field">
                      <label class="label">
                        Description
                        <span class="has-text-danger">*</span>
                      </label>
                      <div class="control">
                        <textarea v-model.trim="FeeTypeObj.description" placeholder="Description.." type="text" class="textarea is-medium" maxlength="300"> </textarea>
                      </div>
                    </div>

 <div class="field" v-if="isService">
                      <label class="label">
                        Service Category
                        <span class="has-text-danger">*</span>
                      </label>
                      <div class="control select is-fullwidth">
                        <select required v-model.trim="serviceCategoryID">
                          <option value>---Select---</option>
                          <option v-for="category in serviceCategories" :key="category.id" :value="category.id">{{category.name}}</option>
                        </select>
                      </div>
                    </div>

                  </div>

                  <div class="column ">
                    <label class="label"> Select Class:<span v-if="!isService" class="has-text-danger">*</span> </label>
                    <span>
                      <b-checkbox v-model="allSelected" @input="checkAllClass()">
                        ALL
                      </b-checkbox>
                    </span>
                    <div class="columns" v-for="chunckData in chunckArray" :key="chunckData.id">
                      <div class="column" v-for="c in chunckData" :key="c.id">
                        <div class="field">
                          <b-checkbox v-model="FeePlanData.classID" @input="selectClass()" :native-value="c.id">
                            {{ c.name }}
                          </b-checkbox>
                        </div>
                      </div>
                    </div>

                    <label class="label">
                      Check List
                      <span class="has-text-danger">*</span>
                    </label>
                    <div class="field">
                      <b-checkbox v-model="FeeTypeObj.isActive"> <b>Is Active </b></b-checkbox>
                    </div>
                    <div class="field">
                      <b-checkbox v-model="FeeTypeObj.isVisibleToParent"> <b>Is VisibleToParent </b> </b-checkbox>
                    </div>
                    <div class="field">
                      <b-checkbox v-model="FeeTypeObj.isRefundable"> <b>Is Refundable </b> </b-checkbox>
                    </div>
                    <div class="field">
                      <b-checkbox v-model="FeeTypeObj.isMandatory"> <b>Is Mandatory </b> </b-checkbox>
                    </div>
                    <div class="field">
                      <b-checkbox v-model="FeeTypeObj.isCompensation"> <b>Is Compensation </b> </b-checkbox>
                    </div>

                  </div>
                </div>
              </div>
            </div>

            <footer class="column has-text-right">
              <button class="button is-success" type="submit">Save</button>
            </footer>
          </card-component>
        </div>
      </form>
    </section>
  </div>
</template>
<script>
import constants from '@/utils/constants'
import CardComponent from '@/components/template/CardComponent'
import _ from 'lodash'
import Multiselect from 'vue-multiselect'
import server from '../../../store/server'
import dialogError from '@/components/dialogError.vue'

export default {
  name: 'AddFeeType',
  components: {
    CardComponent,
    Multiselect
  },
  props: ['id'],
  data () {
    return {
      feeType: [],
      feeTypeID: [],
      feeTypeData: [],
      FeetypeCatList: [],
      academicYears: [],
      classes: [],
      chunckArray: [],
      title: '',
      acadmicyrID: '',
      allSelected: false,
      FeeTypeObj: {
        level: '',
        categoryID: '',
        isActive: true,
        category: '',
        isAdvanceAmount: false,
        isBreakout: false,
        isCompensation: false,
        isExcessAmount: false,
        isInventory: false,
        isMandatory: false,
        isRefundable: false,
        isServiceBased: false,
        isStudentSpecific: false,
        isVisibleToParent: false,
        priority: '',
        name: '',
        loadingComponent: null,
        description: ''
      },
      FeePlanData: {
        classID: []
      },
      isService: false,
      serviceCategories: [],
      serviceCategoryID: ''
    }
  },

  async created () {
    await this.onstart()
    await this.chunkedCustomers()
    await this.getFeeTypeList()
  },
  computed: {
    selectAll: function () {
      return this.classes.every(function (user) {
        return this.FeePlanData.classID
      })
    }
  },
  methods: {
    getCategories: async function () {
      try {
        this.isLoading = true
        let res = await http.get(`${constants.API_URL}/api/service/category/list`)
        this.serviceCategories = res.data
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getFeeTypeList: async function () {
      const data = await server.get('fee-type', this)

      if (_.isEqual(data.success, 200)) {
        this.feeType = data.data.rows
      } else {
        return dialogError.ErrorMsg(data.message, 'is-danger', this)
      }
    },
    onstart: async function () {
      try {
        await this.getCategories()
        await this.getClassList()
        this.title = 'Add Master Category Type'

        // while editing fee structure get detail
        if (this.id) {
          this.loadingComponent = this.$buefy.loading.open()
          this.title = 'Edit Fee Type'
          let { data } = await http.get(`${constants.API_URL}/api/fee-category/${this.id}`)
          if (data) {
            this.FeeTypeObj = {
              isActive: data.isActive,
              isCompensation: data.isCompensation,

              isMandatory: data.isMandatory,
              isRefundable: data.isRefundable,
              isServiceBased: data.isServiceBased,

              isVisibleToParent: data.isVisibleToParent,
              priority: data.priority,

              name: data.name,
              description: data.description,
              level: data.level
            }
            this.isService = data.isService
            this.serviceCategoryID = data.serviceCategoryID
            this.feeTypeID = _.map(data.feeCategoryFeeTypeMaps, 'feeType')
            this.FeePlanData.classID = _.map(data.feeCategoryClassMaps, 'studentClass')
            this.FeePlanData.classID = _.map(this.FeePlanData.classID, 'id')
          }
          this.loadingComponent.close()
        }
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    chunkedCustomers: function () {
      this.chunckArray = _.chunk(this.classes, 3)
    },
    selectClass: async function () {
      this.allSelected = false
    },
    checkAllClass: async function () {
      if (!this.allSelected) {
        this.FeePlanData.classID = []
        return false
      }
      if (this.allSelected) {
        this.classes.map(item => this.FeePlanData.classID.push(item.id))
      }
      this.FeePlanData.classID = _.uniq(this.FeePlanData.classID)
    },
    saveFeeStructure: async function () {
      // this.FeetypeCatList.filter(Obj => {
      //   if (Obj.name === this.FeeTypeObj.category) {
      //     this.FeeTypeObj.categoryID = Obj.id
      //   }
      // })
      try {
        if (this.id) {
          this.loadingComponent = this.$buefy.loading.open()
          let formData = {
            // categoryID: Number(this.FeeTypeObj.categoryID),
            // isAdvanceAmount: this.FeeTypeObj.isAdvanceAmount,
            // isBreakout: this.FeeTypeObj.isBreakout,
            isCompensation: this.FeeTypeObj.isCompensation,
            // isExcessAmount: this.FeeTypeObj.isExcessAmount,
            // isInventory: this.FeeTypeObj.isInventory,
            isMandatory: this.FeeTypeObj.isMandatory,
            isRefundable: this.FeeTypeObj.isRefundable,
            // isServiceBased: this.FeeTypeObj.isServiceBased,
            // isStudentSpecific: this.FeeTypeObj.isStudentSpecific,
            isVisibleToParent: this.FeeTypeObj.isVisibleToParent,
            priority: this.FeeTypeObj.priority,
            name: this.FeeTypeObj.name.toString(),
            description: this.FeeTypeObj.description,
            level: this.FeeTypeObj.level,
            isService: this.isService,
            serviceCategoryID: this.serviceCategoryID ? this.serviceCategoryID : '',
            isActive: this.FeeTypeObj.isActive,
            class: this.FeePlanData.classID,
            feeTypeID: _.map(this.feeTypeID, 'id')
          }
          // if (this.isService && this.serviceCategoryID) {
          //   formData.serviceCategoryID = this.serviceCategoryID
          // }
          await http.put(`${constants.API_URL}/api/fee-category/${this.id}`, formData)
          this.loadingComponent.close()
        } else {
          console.log('classPost--', this.FeePlanData.classID)
          this.loadingComponent = this.$buefy.loading.open()
          let formData = {
            priority: this.FeeTypeObj.priority,
            name: this.FeeTypeObj.name.toString(),
            isActive: this.FeeTypeObj.isActive,
            isMandatory: this.FeeTypeObj.isMandatory,
            isCompensation: this.FeeTypeObj.isCompensation,
            isRefundable: this.FeeTypeObj.isRefundable,
            isVisibleToParent: this.FeeTypeObj.isVisibleToParent,
            description: this.FeeTypeObj.description,
            level: this.FeeTypeObj.level,
            class: this.FeePlanData.classID,
            feeTypeID: _.map(this.feeTypeID, 'id'),
            isService: this.isService,
            serviceCategoryID: this.serviceCategoryID
            // categoryID: Number(this.FeeTypeObj.categoryID),
            // isAdvanceAmount: this.FeeTypeObj.isAdvanceAmount,
            // isBreakout: this.FeeTypeObj.isBreakout,
            // isCompensation: this.FeeTypeObj.isCompensation,
            // isExcessAmount: this.FeeTypeObj.isExcessAmount,
            // isInventory: this.FeeTypeObj.isInventory,
            // isMandatory: this.FeeTypeObj.isMandatory,
            // isRefundable: this.FeeTypeObj.isRefundable,
            // isServiceBased: this.FeeTypeObj.isServiceBased,
            // isStudentSpecific: this.FeeTypeObj.isStudentSpecific,
            // isVisibleToParent: this.FeeTypeObj.isVisibleToParent,
            // priority: this.FeeTypeObj.priority,
            // name: this.FeeTypeObj.name.toString(),
            // description: this.FeeTypeObj.description,
            // level: this.FeeTypeObj.level
          }
          // if (this.isService && this.serviceCategoryID) {
          //   formData.serviceCategoryID = this.serviceCategoryID
          // }
          await http.post(`${constants.API_URL}/api/fee-category`, formData)
          this.loadingComponent.close()
        }

        this.$router.push({ name: 'FeeTypeList' })
        this.$buefy.dialog.alert({
          type: 'is-success',
          message: 'Saved successfully',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    getClassList: async function () {
      try {
        const classes = await http.get(`${constants.API_URL}/api/students/class`)
        this.classes = classes.data.rows
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
